import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Layanan from "../components/Layanan";
import PaketPopuler from "../components/PaketPopuler";
import Destinations from "../components/Destinations";
import Hotels from "../components/Hotels";
import TravelMoments from "../components/TravelMoments";
import Armada from "../components/Armada";
import KenapaKami from "../components/KenapaKami";
import Testimonial from "../components/Testimonial";
import CtaBanner from "../components/CtaBanner";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingChat";
import ContactDialog from "../components/ContactDialog";
import QuickLead from "../components/QuickLead";

export default function Landing() {
  const [contactOpen, setContactOpen] = useState(false);
  const openContact = () => setContactOpen(true);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#FBFAF6] text-[#0C2230]">
      <Navbar onContact={openContact} />
      <main>
        <Hero />
        <Layanan />
        <PaketPopuler />
        <Destinations />
        <Hotels />
        <TravelMoments />
        <Armada />
        <KenapaKami />
        <Testimonial />
        <CtaBanner />
      </main>
      <Footer onContact={openContact} />
      <FloatingWhatsApp />
      <QuickLead />
      <ContactDialog open={contactOpen} onOpenChange={setContactOpen} />
    </div>
  );
}
